import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Params } from "@angular/router";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";

@Injectable({
  providedIn: "root",
})
export class ReportsService extends BaseService {
  constructor() {
    super();
  }
  // Get all products details
  getCommissions(params) {
    return this.httpService.getParams(APIUrl.commissions, params);
  }
  getcommissionSummary(params) {
    return this.httpService.getParams(APIUrl.commissionSummary, params);
  }
  getPayments(params) {
    return this.httpService.getParams(APIUrl.payments, params);
  }
  getpaymentSummary(params) {
    return this.httpService.getParams(APIUrl.paymentSummary, params);
  }
  getreatileracquisition(params) {
    return this.httpService.getParams(APIUrl.reatileracquisition, params);
  }
  getreatileracquisitionSummary(params) {
    return this.httpService.getParams(
      APIUrl.reatileracquisitionSummary,
      params
    );
  }
  getloyality(params) {
    return this.httpService.getParams(APIUrl.loyality, params);
  }
  getloyalitySummary(params) {
    return this.httpService.getParams(APIUrl.loyalitySummary, params);
  }
  getrealtime(params) {
    return this.httpService.getParams(APIUrl.realtime, params);
  }
  getrealtimeSummary(params) {
    return this.httpService.getParams(APIUrl.realtimeSummary, params);
  }
  getsales(params) {
    return this.httpService.getParams(APIUrl.sales, params);
  }
  getsalesSummary(params) {
    return this.httpService.getParams(APIUrl.salesSummary, params);
  }

  approveACHDD(retailerPaymentId) {
    let params = new HttpParams().set("retailerPaymentId", retailerPaymentId);
    return this.httpService.getParams(APIUrl.approveACHDD, params);
  }
  rejectACHDD(retailerPaymentId) {
    let params = new HttpParams().set("retailerPaymentId", retailerPaymentId);
    return this.httpService.getParams(APIUrl.rejectACHDD, params);
  } 
  batchExportList() {
    let url = APIUrl.batchExportList;
    return this.httpService.get(url);
  }
  createBatchExport() {
    let url = APIUrl.createBatchExport;
    let params: any = new HttpParams()
      .set("endDate", null)
      .set("startDate", null);
    return this.httpService.getParams(url, params);
  }
  getrefund(params) {
    return this.httpService.getParams(APIUrl.refund, params);
  }
  getrefundSummary(params) {
    return this.httpService.getParams(APIUrl.refundSummary, params);
  }
  approvePinlessrefund(params) {
    return this.httpService.post(APIUrl.pinlessrefund, params);
  }

  getinvoicepayments(params) {
    return this.httpService.get(APIUrl.invoicepayments);
  }
}
